import React, { useState, useEffect } from "react";
import { DragAndDrop, Drag, Drop } from "../../../../helpers/dnd";
import { reorder } from "../../../../helpers/dnd/Dnd_helpers";

// Import components
import Title from './Title';
import Rule from './Rule';
import Document from './Document';
import FileGroup from './FileGroup';
import AIplu from './AIplu';
import AIpluFake from './AIpluFake';
import ZoneUrba from './ZoneUrba';
import ZoneUrba2 from './ZoneUrba2';
import ZoneCity from './ZoneCity';

// Import external functions
import * as nodeHelpers from '../../ruleEditor_elements/helpers/NodeHelpers';
import * as rulesHelpers from '../../ruleEditor_elements/helpers/RulesHelpers';

// Import CSS & assets
import './List.css';
import ico_file from '../../../../assets/ico/ico_file.svg';
import ico_file_white from '../../../../assets/ico/ico_file_white.svg';
import ico_download from '../../../../assets/ico/ico_download.svg';
import ico_map_layers from '../../../../assets/ico/ico_map_layers.svg';
import ico_arrow from '../../../../assets/ico/ico_arrow_up.svg';
import DocIdItem from "./DocIdItem";



const List = ({ capacity, setCapacity, mapLayers, setMapLayers, categories, setCategories, ruleCatalog_Open, setRuleUpdateTracker, highlightedRule, setHighlightedRule, mapDrawMode, setMapDrawMode, hiddenRule, setHiddenRule, zoneUrba2_mapShow, setZoneUrba2_mapShow }) => {

    // LAYER : Toggle
    const layer_Toggle = (layer) => {
        // console.log("TOGGLE LAYER", layer);
        // Get state
        var mapLayersState = mapLayers;
        // Update state
        mapLayersState[layer]["isVisible"] = !mapLayersState[layer]["isVisible"];
        // Update original
        setMapLayers({ ...mapLayersState });
    }

    const [isZoneUrbaOpened, setIsZoneUrbaOpened] = useState(false);
    const handleZoneUrbaOpening = () => {
        var delay = 0;
        if (isZoneUrbaOpened === true && document.getElementById("zoneUrba_list").getBoundingClientRect().top < 130) {
            // Scroll
            var topList = document.getElementById("zoneUrba_list").offsetTop;
            var topSection = document.getElementById("section_5").offsetTop;
            document.getElementById("section_data").scrollTop = topSection + topList + 14;
            delay = capacity?.rules?.gpu_data?.zoneUrba_all.length * 10;
        }
        setTimeout(() => {
            setIsZoneUrbaOpened(!isZoneUrbaOpened);
        }, delay);
    }

    // useEffect(() => {
    // console.log("UPDATED CATEGORIES", categories);
    // }, [categories]);
    // useEffect(() => {
    // console.log("UPDATED RULESET", capacity.rules.ruleset);
    // }, [capacity.rules.ruleset]);

    // const [categories, setCategories] = useState([
    //     {
    //         id: "q101",
    //         name: "Category 1",
    //         items: [
    //             { id: "abc", name: "First" },
    //             { id: "def", name: "Second" }
    //         ]
    //     },
    //     {
    //         id: "wkqx",
    //         name: "Category 2",
    //         items: [
    //             { id: "ghi", name: "Third" },
    //             { id: "jkl", name: "Fourth" }
    //         ]
    //     }
    // ]);



    // _____ ZONE URBA & ZONE CITY
    // const [zoneUrba2_mapShow, setZoneUrba2_mapShow] = useState([]);

    const zoneUrba2_mapShow_change = (zoneUrba2_id) => {
        // REMOVE
        if (zoneUrba2_mapShow.includes(zoneUrba2_id)) {
            var zoneUrba2_mapShow_new = [];
            zoneUrba2_mapShow.forEach((zu2_id) => {
                if (zu2_id !== zoneUrba2_id) { zoneUrba2_mapShow_new.push(zu2_id) }
            })
            setZoneUrba2_mapShow(zoneUrba2_mapShow_new);
        }
        // ADD
        else {
            var zoneUrba2_mapShow_new = JSON.parse(JSON.stringify(zoneUrba2_mapShow));
            zoneUrba2_mapShow_new.push(zoneUrba2_id);
            setZoneUrba2_mapShow(zoneUrba2_mapShow_new);
        }
    }
    // useEffect(() => {
    //     console.log("UPDATED ZONE URBA MAP SHOW", zoneUrba2_mapShow);
    // }, [zoneUrba2_mapShow]);

    const zoneUrba2_Create = () => {
        // console.log("CREATE ZONE URBA 2");
        // Creat new element model
        var zoneUrba2_new = {
            properties: {
                id: "zu2_" + (Date.now()).toString(),
                libelle: "Nouvelle zone",
                libelong: "Description de la zone",
                label: "",
            },
            geometry: {}
        }
        // Get current rules
        var rules = capacity.rules;
        // Check if zoneUrba2 exists
        if (!rules?.gpu_data?.zoneUrba2) {
            rules.gpu_data.zoneUrba2 = [];
        }
        if (!rules?.gpu_data?.zoneUrba2_all) {
            rules.gpu_data.zoneUrba2_all = [];
        }
        // Add new zoneUrba2
        rules.gpu_data.zoneUrba2_all.push(zoneUrba2_new);
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const zoneUrba2_Delete = (zoneUrba2_Id) => {
        // console.log("DELETE ZONE URBA 2", zoneUrba2_Id);
        // Get current rules
        var rules = capacity.rules;
        // Remove zoneUrba2
        var zoneUrba2_all_new = [];
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id !== zoneUrba2_Id) {
                zoneUrba2_all_new.push(rules.gpu_data.zoneUrba2_all[i]);
            }
        }
        rules.gpu_data.zoneUrba2_all = zoneUrba2_all_new;
        // Remove from map show
        if (zoneUrba2_mapShow.includes(zoneUrba2_Id)) {
            zoneUrba2_mapShow_change(zoneUrba2_Id);
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const libelle_update = (zoneUrba2_Id, libelle) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id === zoneUrba2_Id) {
                rules.gpu_data.zoneUrba2_all[i].properties.libelle = libelle;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const description_update = (zoneUrba2_Id, description) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id === zoneUrba2_Id) {
                rules.gpu_data.zoneUrba2_all[i].properties.libelong = description;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const label_update = (zoneUrba2_Id, label) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        var zu2_index = null;
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id === zoneUrba2_Id) {
                rules.gpu_data.zoneUrba2_all[i].properties.label = label;
                zu2_index = i;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        // toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all__" + zu2_index + "__properties__label");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const index_update = (zoneUrba2_Id, index) => {
        console.log("CHANGE INDEX TO", index);
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba index
        var zu2_index = null;
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id === zoneUrba2_Id) {
                zu2_index = i;
                break;
            }
        }
        console.log("zu2_index", zu2_index);
        // Create new list
        var zoneUrba2_all_reordered = [];
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            console.log("i", i);
            if (i === index) {
                zoneUrba2_all_reordered.push(rules.gpu_data.zoneUrba2_all[zu2_index]);
                console.log("i = index");
            }
            if (i !== zu2_index) {
                zoneUrba2_all_reordered.push(rules.gpu_data.zoneUrba2_all[i]);
                console.log("i != zu2_index");
            }
        }
        if (index >= rules.gpu_data.zoneUrba2_all.length) {
            zoneUrba2_all_reordered.push(rules.gpu_data.zoneUrba2_all[zu2_index]);
            console.log("add last position");
        }
        console.log("zoneUrba2_all_reordered", zoneUrba2_all_reordered);
        // Replace new list
        rules.gpu_data.zoneUrba2_all = zoneUrba2_all_reordered;
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const geojson_update = (zoneUrba2_Id, geojson, interesctions) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        var zu2_index = null;
        for (var i = 0; i < rules.gpu_data.zoneUrba2_all.length; i++) {
            if (rules.gpu_data.zoneUrba2_all[i].properties.id === zoneUrba2_Id) {
                rules.gpu_data.zoneUrba2_all[i].geometry = geojson;
                rules.gpu_data.zoneUrba2_all[i].properties.intersections = interesctions;
                zu2_index = i;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        // toSaveData.keys.push("rules__gpu_data__zoneUrba2_all");
        toSaveData.keys.push("rules__gpu_data__zoneUrba2_all__" + zu2_index);
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const zoneCity_Create = () => {
        // console.log("CREATE ZONE CITY");
        // Creat new element model
        var zoneCity_new = {
            properties: {
                id: "zc_" + (Date.now()).toString(),
                libelle: "Commune",
                postcode: "Code postal",
                inseecode: ["Code INSEE"],
            },
            geometry: {}
        }
        // Get current rules
        var rules = capacity.rules;
        // Check if zoneCity_all exists
        if (!rules?.gpu_data?.zoneCity_all) {
            rules.gpu_data.zoneCity_all = [];
        }
        // Add new zoneUrba2
        rules.gpu_data.zoneCity_all.push(zoneCity_new);
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneCity_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const cityname_update = (zoneCity_Id, libelle) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        for (var i = 0; i < rules.gpu_data.zoneCity_all.length; i++) {
            if (rules.gpu_data.zoneCity_all[i].properties.id === zoneCity_Id) {
                rules.gpu_data.zoneCity_all[i].properties.libelle = libelle;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneCity_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const postcode_update = (zoneCity_Id, description) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        for (var i = 0; i < rules.gpu_data.zoneCity_all.length; i++) {
            if (rules.gpu_data.zoneCity_all[i].properties.id === zoneCity_Id) {
                rules.gpu_data.zoneCity_all[i].properties.postcode = description;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneCity_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const inseecode_update = (zoneCity_Id, description) => {
        // Get current rules
        var rules = capacity.rules;
        // Search zoneUrba
        for (var i = 0; i < rules.gpu_data.zoneCity_all.length; i++) {
            if (rules.gpu_data.zoneCity_all[i].properties.id === zoneCity_Id) {
                rules.gpu_data.zoneCity_all[i].properties.inseecode = description;
                break;
            }
        }
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__zoneCity_all");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }

    // DOC ID REFs
    const docIdRef_Create = () => {
        // console.log("CREATE DOC ID REF");
        // Get current rules
        var rules = capacity.rules;
        // Check if id_list exists
        if (!rules?.gpu_data?.document?.id_list) {
            rules.gpu_data.document.id_list = [rules.gpu_data.document?.id];
        }
        // Add new item
        rules.gpu_data.document.id_list.push("");
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__document");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }
    const docIdRef_Update = (docIdRef_index, libelle) => {
        console.log("UPDATE DOC ID REF", docIdRef_index);
        // Get current rules
        var rules = capacity.rules;
        // Update ref
        if (rules?.gpu_data?.document?.id_list && rules.gpu_data.document.id_list.length >= (docIdRef_index + 1)) {
            rules.gpu_data.document.id_list[docIdRef_index] = libelle;
            // toSave params
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules__gpu_data__document");
            toSaveData.autoSave = true;
            toSaveData.action = "";
            toSaveData.value = "";
            // Update capacity
            setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
        }
    }
    const docIdRef_Delete = (docIdRef_index) => {
        // Get current rules
        var rules = capacity.rules;
        // Remove ref
        var id_list_new = [];
        for (var i = 0; i < rules.gpu_data.document.id_list.length; i++) {
            if (i !== docIdRef_index) {
                id_list_new.push(rules.gpu_data.document.id_list[i]);
            }
        }
        rules.gpu_data.document.id_list = id_list_new;
        // toSave params
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__gpu_data__document");
        toSaveData.autoSave = true;
        toSaveData.action = "";
        toSaveData.value = "";
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }





    const handleDragEnd = (result) => {
        const { type, source, destination } = result;
        if (!destination) return;

        const sourceCategoryId = source.droppableId;
        const destinationCategoryId = destination.droppableId;
        // console.log("sourceCategoryId", sourceCategoryId);
        // console.log("destinationCategoryId", destinationCategoryId);

        // Reordering items
        if (type === "droppable-item") {
            // If drag and dropping within the same category
            if (sourceCategoryId === destinationCategoryId) {
                const updatedOrder = reorder(
                    capacity.rules.ruleset.find((ruleGroup) => ruleGroup.id === sourceCategoryId).items,
                    source.index,
                    destination.index
                );
                const updatedCategories = capacity.rules.ruleset.map((ruleGroup) =>
                    ruleGroup.id !== sourceCategoryId
                        ? ruleGroup
                        : { ...ruleGroup, items: updatedOrder }
                );
                // console.log("updatedCategories", updatedCategories);
                // setCategories(updatedCategories);

                // Update capacity
                var rules = capacity.rules;
                rules.ruleset = updatedCategories;
                // Set numerotation
                rules = rulesHelpers.getRulesNumerotation(rules);
                setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
                setRuleUpdateTracker((Date.now()).toString());

            } else {
                const sourceOrder = capacity.rules.ruleset.find(
                    (category) => category.id === sourceCategoryId
                ).items;
                const destinationOrder = capacity.rules.ruleset.find(
                    (category) => category.id === destinationCategoryId
                ).items;

                const [removed] = sourceOrder.splice(source.index, 1);
                destinationOrder.splice(destination.index, 0, removed);

                destinationOrder[removed] = sourceOrder[removed];
                delete sourceOrder[removed];

                const updatedCategories = capacity.rules.ruleset.map((category) =>
                    category.id === sourceCategoryId
                        ? { ...category, items: sourceOrder }
                        : category.id === destinationCategoryId
                            ? { ...category, items: destinationOrder }
                            : category
                );
                // console.log("updatedCategories", updatedCategories);
                // setCategories(updatedCategories);
                // Update capacity
                var rules = capacity.rules;
                rules.ruleset = updatedCategories;
                // Set numerotation
                rules = rulesHelpers.getRulesNumerotation(rules);
                setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
                setRuleUpdateTracker((Date.now()).toString());
            }
        }

        // Reordering categories
        if (type === "droppable-category") {
            const updatedCategories = reorder(
                capacity.rules.ruleset,
                source.index,
                destination.index
            );
            // console.log("updatedCategories", updatedCategories);
            // setCategories(updatedCategories);
            // Update capacity
            var rules = capacity.rules;
            rules.ruleset = updatedCategories;
            // Set numerotation
            rules = rulesHelpers.getRulesNumerotation(rules);
            setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
            setRuleUpdateTracker((Date.now()).toString());
        }
    };

    // __________ RULEGROUPS
    const ruleGroup_Create = () => {
        // console.log("CREATE RULE GROUP");
        // Creat new element model
        var documentNew = {
            id: "ruleGroup_" + (Date.now()).toString(),
            name: "Nouvel ensemble de règles",
            items: []
        }
        // setCategories(prevValue => [...prevValue, documentNew]);
        // Get current rules
        var rules = capacity.rules;
        // Add new ruleGroup
        rules.ruleset.push(documentNew);
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Création d'un nouvel ensemble de règles", value: "" } });
    }

    const ruleGroup_Update = (ruleGroup_Id, ruleGroup_Name, action, value, fromAI) => {
        // Get current rules
        var rules = capacity.rules;
        // Update ruleset
        rules.ruleset.forEach(ruleGroup => {
            if (ruleGroup.id === ruleGroup_Id) {
                ruleGroup.name = ruleGroup_Name;
                fromAI ? ruleGroup.isFromAI = true : ruleGroup.isFromAI = false;
            }
        })
        // Set numerotation
        if (!fromAI) {
            rules = rulesHelpers.getRulesNumerotation(rules);
        }
        // Update capacity
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__ruleset");
        toSaveData.autoSave = true;
        toSaveData.action = action;
        toSaveData.value = value;
        if (fromAI) {
            toSaveData.autoSave = false;
            toSaveData.action = "Règlement mis à jour avec";
            toSaveData.value = "l'outil d'analyse IA";
        }
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }

    const ruleGroup_Duplicate = (ruleGroup_Id) => {
        // Get current rules
        var rules = capacity.rules;
        // Update ruleset
        var ruleset = [];
        rules.ruleset.forEach(ruleGroup => {
            ruleset.push(ruleGroup);
            if (ruleGroup.id === ruleGroup_Id) {
                var ruleGroup_duplicated = JSON.parse(JSON.stringify(ruleGroup));
                ruleGroup_duplicated.id = ruleGroup_duplicated.id + "c";
                ruleGroup_duplicated.name = ruleGroup_duplicated.name + " (copie)";
                ruleGroup_duplicated.isFromAI = false;
                ruleGroup_duplicated.items.forEach(ruleGroup_item => {
                    ruleGroup_item.id = ruleGroup_item.id + "c";
                })
                ruleset.push(ruleGroup_duplicated);
            }
        })
        rules.ruleset = ruleset;
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__ruleset");
        toSaveData.autoSave = false;
        console.log(rules);
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
        setRuleUpdateTracker("-" + (Date.now()).toString());
    }

    const ruleGroup_ZoneUrba_Update = (ruleGroup_Id, zoneUrba_list,) => {
        // console.log("UPDATIN GROUP ZU", zoneUrba_list);
        // Get current rules
        var rules = capacity.rules;
        // Update ruleset
        rules.ruleset.forEach(ruleGroup => {
            if (ruleGroup.id === ruleGroup_Id) {
                ruleGroup.zonesUrba = zoneUrba_list;
            }
        })
        // Update capacity
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__ruleset");
        toSaveData.autoSave = true;
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
    }

    const ruleGroup_Delete = (ruleGroup_Id) => {
        // console.log("DELETE RULE GROUP", ruleGroup_Id);
        var value = "";
        // Get current rules
        var rules = capacity.rules;
        // Get current ruleset
        var ruleset = rules.ruleset;
        // Create new ruleset
        var rulesetNew = [];
        ruleset.forEach(ruleGroup => {
            if (ruleGroup.id !== ruleGroup_Id) {
                rulesetNew.push(ruleGroup);
            }
            else {
                value = ruleGroup.name;
            }
        })
        // Update rules
        rules.ruleset = rulesetNew;
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        // Update capacity
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("rules__ruleset");
        toSaveData.autoSave = true;
        toSaveData.action = "Suppression de l'ensemble de règles intitulé";
        toSaveData.value = value;
        setCapacity({ ...capacity, rules: rules, toSave: toSaveData });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "Suppression de l'ensemble de règles intitulé", value: value } });
        setRuleUpdateTracker((Date.now()).toString());
    }


    // __________ TITLES
    const title_Create = (documentId) => {
        // console.log("CREATE TITLE", documentId);
        // Create new element model
        var titleNew = { id: (Date.now()).toString(), name: "Nouveau titre", type: "title" };
        // Get current rules
        var rules = capacity.rules;
        // Get current ruleset
        var ruleset = rules.ruleset;
        // Add title
        ruleset.forEach(ruleGroup => {
            if (ruleGroup.id === documentId) {
                ruleGroup.items.push(titleNew);
            }
        })
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "", value: "" } });
    }

    const title_Update = (title_Id, title_name) => {
        // Get current rules
        var rules = capacity.rules;
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === title_Id) {
                    rules.ruleset[i].items[j].name = title_name;
                    break;
                }
            }
        }
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "", value: "" } });
    }

    const title_Delete = (title_Id) => {
        // console.log("DELETE TITLE", title_Id);
        // Get current rules
        var rules = capacity.rules;
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            var itemsNew = [];
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id !== title_Id) {
                    itemsNew.push(rules.ruleset[i].items[j]);
                }
            }
            rules.ruleset[i].items = itemsNew;
        }
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "", value: "" } });
    }

    const title_OpenClose = (title_Id, type) => {
        // console.log("TITLE OPENCLOSE", title_Id, type);
        // Get rules insadie title
        var rules_inside = [];
        var is_inside = false;
        var rules = capacity.rules;
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (is_inside === true && rules.ruleset[i].items[j].type === "rule") {
                    rules_inside.push(rules.ruleset[i].items[j]);
                    // console.log("item_", rules.ruleset[i].items[j].id);
                    var element = document.querySelectorAll('[data-rbd-draggable-id="item_' + rules.ruleset[i].items[j].id + '"]');
                    // console.log("element", element);
                    if (element.length > 0) {
                        if (type === false) {
                            element[0].classList.add("app__ruleset_rule_container_hidden");
                        }
                        else {
                            element[0].classList.remove("app__ruleset_rule_container_hidden");
                        }
                    }
                }
                else {
                    is_inside = false;
                }

                if (rules.ruleset[i].items[j].id === title_Id) {
                    is_inside = true;
                }
            }
        }

        var element_info = document.getElementById("title_info__" + title_Id);
        if (element_info) {
            if (type === false) {
                if (rules_inside.length > 1) {
                    element_info.innerText = rules_inside.length + " règles";
                }
                else if (rules_inside.length === 1) {
                    element_info.innerText = "1 règle";
                }
                else {
                    element_info.innerText = "";
                }
            }
            else {
                element_info.innerText = "";
            }
        }
        // console.log("rules_inside", rules_inside);

    }

    // __________ RULES
    const rule_Create = (documentId) => {
        // console.log("CREATE RULE", documentId);
        var ruleNew = { id: (Date.now()).toString(), name: "Nouvelle règle", type: "rule" };
        var prevValue = [...categories];
        // console.log("prevValue", prevValue);
        prevValue.forEach(category => {
            if (category.id === documentId) {
                category.items.push(ruleNew);
            }
        });
        setCategories(prevValue);
    }

    const rule_Update = (ruleId, newRuleData, newRuleInterpreted) => {
        // console.log("UPDATE RULE", ruleId);
        // Get current rules
        var rules = { ...capacity.rules };
        var ruleName = "";
        var variables_text = "";
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === ruleId) {
                    rules.ruleset[i].items[j].data = { ...newRuleData };
                    if (newRuleInterpreted !== null) {
                        rules.ruleset[i].items[j].interpreted = newRuleInterpreted;
                    }
                    ruleName = rules.ruleset[i].items[j].name;
                    // Add variables
                    variables_text = " (";
                    var variables = rules.ruleset[i].items[j].data.variables_description.concat(rules.ruleset[i].items[j].data.variables_input);
                    variables.forEach((variable, variable_index) => {
                        if (variable_index > 0 && variable_index === variables.length - 1) { variables_text = variables_text + " et " }
                        else if (variable_index > 0) { variables_text = variables_text + ", " }
                        variables_text = variables_text + variable.label + " = " + variable.value
                    })
                    variables_text = variables_text + ")";
                    break;
                }
            }
        }
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // console.log("new rules", rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "Mise à jour des valeurs de la règle", value: ruleName + variables_text, keys: ["rules__ruleset"] } });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
        setRuleUpdateTracker((Date.now()).toString());
    }

    const rule_Update_Source = (ruleId, newRuleSources) => {
        // console.log("UPDATE RULE SOURCE", ruleId);
        // Get current rules
        var rules = { ...capacity.rules };
        var ruleName = "";
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === ruleId) {
                    ruleName = rules.ruleset[i].items[j].name;
                    rules.ruleset[i].items[j].sources = newRuleSources;
                    break;
                }
            }
        }
        // Set numerotation
        // rules = rulesHelpers.getRulesNumerotation(rules);
        // console.log("new rules", rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Mise à jour de la source de la règle", value: ruleName, keys: ["rules__ruleset"] } });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
        // setRuleUpdateTracker((Date.now()).toString());
    }

    const rule_Update_Comment = (ruleId, newRuleComment) => {
        // console.log("UPDATE RULE SOURCE", ruleId);
        // Get current rules
        var rules = { ...capacity.rules };
        var ruleName = "";
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === ruleId) {
                    ruleName = rules.ruleset[i].items[j].name;
                    rules.ruleset[i].items[j].comment = newRuleComment;
                    break;
                }
            }
        }
        // Set numerotation
        // rules = rulesHelpers.getRulesNumerotation(rules);
        // console.log("new rules", rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Mise à jour du commentaire de la règle", value: ruleName, keys: ["rules__ruleset"] } });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
        // setRuleUpdateTracker((Date.now()).toString());
    }

    const rule_Update_Title = (ruleId, newRuleTitle) => {
        // console.log("UPDATE RULE SOURCE", ruleId);
        // Get current rules
        var rules = { ...capacity.rules };
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === ruleId) {
                    rules.ruleset[i].items[j].name = newRuleTitle;
                    break;
                }
            }
        }
        // Set numerotation
        // rules = rulesHelpers.getRulesNumerotation(rules);
        // console.log("new rules", rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Mise à jour du titre de la règle", value: newRuleTitle, keys: ["rules__ruleset"] } });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
        // setRuleUpdateTracker((Date.now()).toString());
    }

    const rule_Update_Ignorance = (ruleId, isIgnored) => {
        // console.log("UPDATE RULE SOURCE", ruleId);
        // Get current rules
        var rules = { ...capacity.rules };
        var ruleName = "";
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id === ruleId) {
                    ruleName = rules.ruleset[i].items[j].name;
                    rules.ruleset[i].items[j].isIgnored = isIgnored;
                    break;
                }
            }
        }
        // Set numerotation
        // rules = rulesHelpers.getRulesNumerotation(rules);
        // console.log("new rules", rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Mise à jour de l'ignorace de la règle", value: ruleName, keys: ["rules__ruleset"] } });
        // setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "", value: "" } });
        setRuleUpdateTracker((Date.now()).toString());
    }

    const rule_Delete = (rule_Id) => {
        // console.log("DELETE RULE", rule_Id);
        var ruleTitle = "";
        // Get current rules
        var rules = capacity.rules;
        // Search title
        for (var i = 0; i < rules.ruleset.length; i++) {
            var itemsNew = [];
            for (var j = 0; j < rules.ruleset[i].items.length; j++) {
                if (rules.ruleset[i].items[j].id !== rule_Id) {
                    itemsNew.push(rules.ruleset[i].items[j]);
                }
                else {
                    ruleTitle = rules.ruleset[i].items[j].name;
                }
            }
            rules.ruleset[i].items = itemsNew;
        }
        // Set numerotation
        rules = rulesHelpers.getRulesNumerotation(rules);
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "Suppression de la règle", value: ruleTitle, keys: ["rules"] } });
        setRuleUpdateTracker((Date.now()).toString());
    }

    const condition_Delete = (ruleId) => {
        // console.log("REMOVE CONDITION to " + ruleId);
        // Get current rules
        var rules = capacity.rules;
        // Get current ruleset
        var ruleset = rules.ruleset;
        // Search rule
        var ruleTitle = "";
        ruleset.forEach(ruleGroup => {
            ruleGroup.items.forEach(item => {
                if (item.id === ruleId) {
                    ruleTitle = item.name;
                    // Create params if does not exists
                    if (!item?.data?.params) {
                        item.data.params = {
                            "condition": {
                                "value": false,
                                "data": null
                            },
                            "perimeter": {
                                "value": false,
                                "data": null
                            }
                        }
                    }
                    // Update params
                    item.data.params.condition = {
                        value: true,
                        data: null
                    }
                    // Re interpret rule
                    item.interpreted = nodeHelpers.nodeInterpretor(item.data.composition.nodes[0].data.source, capacity, item?.data?.params?.perimeter);
                }
            })
        })
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "Suppression de la condition d'application de la règle", value: ruleTitle, keys: ["rules"] } });
        setRuleUpdateTracker((Date.now()).toString());
    }

    const perimeter_Delete = (ruleId) => {
        // console.log("REMOVE PERIMETER to " + ruleId);
        // Get current rules
        var rules = capacity.rules;
        // Get current ruleset
        var ruleset = rules.ruleset;
        // Search rule
        var ruleTitle = "";
        ruleset.forEach(ruleGroup => {
            ruleGroup.items.forEach(item => {
                if (item.id === ruleId) {
                    ruleTitle = item.name;
                    // Create params if does not exists
                    if (!item?.data?.params) {
                        item.data.params = {
                            "condition": {
                                "value": false,
                                "data": null
                            },
                            "perimeter": {
                                "value": false,
                                "data": null
                            }
                        }
                    }
                    // Update params
                    item.data.params.perimeter = {
                        value: true,
                        data: null
                    }
                    // Re interpret rule
                    if (item?.data?.params?.condition?.data?.data?.interpreted === false) {
                        item.interpreted = [];
                    }
                    else {
                        item.interpreted = nodeHelpers.nodeInterpretor(item.data.composition.nodes[0].data.source, capacity);
                    }
                }
            })
        })
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: false, action: "Suppression du périmètre d'application de la règle", value: ruleTitle, keys: ["rules"] } });
        setRuleUpdateTracker((Date.now()).toString());
    }

    // AI
    const [isAIRunning, setIsAIRunning] = useState(false);

    // FILES
    const file_Update_Params = (file, params) => {
        console.log("UPDATE FILE PARAMS", file);
        // Get current file
        var rules = { ...capacity.rules };
        // Search file
        var files_keys_n1 = Object.keys(rules.gpu_data.files);
        for (var i = 0; i < files_keys_n1.length; i++) {
            if (files_keys_n1[i] === "Règlements") {
                var files_keys_n2 = Object.keys(rules.gpu_data.files[files_keys_n1[i]]);
                for (var j = 0; j < files_keys_n2.length; j++) {
                    for (var k = 0; k < rules.gpu_data.files[files_keys_n1[i]][files_keys_n2[j]].length; k++) {
                        if (rules.gpu_data.files[files_keys_n1[i]][files_keys_n2[j]][k]?.name === file.name) {
                            console.log("MATCH FILE");
                            rules.gpu_data.files[files_keys_n1[i]][files_keys_n2[j]][k].params = params;
                            break;
                        }
                    }
                }
            }
            else {
                for (var k = 0; k < rules.gpu_data.files[files_keys_n1[i]].length; k++) {
                    if (rules.gpu_data.files[files_keys_n1[i]][k]?.name === file.name) {
                        console.log("MATCH FILE");
                        rules.gpu_data.files[files_keys_n1[i]][k].params = params;
                        break;
                    }
                }
            }
        }
        // Update capacity
        setCapacity({ ...capacity, rules: rules, toSave: { autoSave: true, action: "Mise à jour du document d'urbanisme", value: file?.title, keys: ["rules__gpu_data__files"] } });
    }


    return (
        <>
            {/* GPU */}
            {capacity?.rules?.gpu_data && capacity?.rules?.gpu_data !== "fetching" && capacity?.rules?.gpu_data?.document && capacity?.rules?.gpu_data?.document !== "error" && capacity?.rules?.gpu_data?.zoneUrba !== "error" &&
                <>
                    {/* <div className="app__sectiondata_widget_title">Référencement du terrain</div> */}
                    <div className="app__sectiondata_widget_title_container">
                        <div className="app__sectiondata_widget_title">Référencement du terrain</div>
                        <div className="app__sectiondata_widget_layer">
                            {/* <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch_rules" checked={mapLayers.rules.isVisible} onChange={() => { layer_Toggle("rules") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch_rules">Toggle</label></div> */}
                        </div>
                    </div>
                    {/* ZONING URBA CONCAT */}
                    {(capacity.isModel === false && (capacity?.rules?.gpu_data?.zoneUrbaLabel && capacity?.rules?.gpu_data?.zoneUrbaLabel !== "")) &&
                        <>
                            <div className="app__sectiondata__widget">
                                <div className="app__sectiondata_widget_title">Zonage PLU complet</div>
                                <div className="app__sectiondata_widget_value_container">
                                    <div className="app__ruleset_document_title" style={{ marginBottom: "4px" }}>Terrain classé en {capacity?.rules?.gpu_data?.zoneUrbaLabel}</div>
                                </div>
                            </div>
                            <div className="app__sectiondata_widget_spacer_10"></div>
                        </>
                    }
                    {/* ZONING URBA 1 */}
                    <div className="app__sectiondata__widget">
                        <div className="app__sectiondata_widget_title">Zonage PLU principal</div>
                        <div className="app__sectiondata_widget_value_container">
                            {capacity.isModel === false ?
                                // CAPACITY VERSION
                                <>
                                    <div className="app__ruleset_document_title" style={{ marginBottom: "4px" }}>
                                        {/* <div className="app__sectiondata_widget_value_text_xsmall" style={{ marginBottom: "4px" }}> */}
                                        {capacity?.rules?.gpu_data?.zoneUrba.length === 1 &&
                                            <>
                                                {(capacity?.rules?.gpu_data?.zoneUrbaLabel && capacity?.rules?.gpu_data?.zoneUrbaLabel !== "") ? "Zone " : "Terrain classé en zone "}{capacity?.rules?.gpu_data?.zoneUrba[0]?.properties?.libelle}
                                            </>
                                        }
                                        {capacity?.rules?.gpu_data?.zoneUrba.length > 1 &&
                                            <>
                                                Terrain classé en zones{capacity?.rules?.gpu_data?.zoneUrba.map((zonePLU, index) => {
                                                    var prefix = ", ";
                                                    if (index === 0) { prefix = " " }
                                                    else if (index === capacity?.rules?.gpu_data?.zoneUrba.length - 1) { prefix = " et " }
                                                    return (
                                                        <span key={"span_" + index}>
                                                            {prefix}<span style={{ fontSize: "18px", fontWeight: "800" }}>{zonePLU?.properties?.libelle}</span>
                                                        </span>
                                                    )
                                                })}
                                            </>
                                        }
                                    </div>
                                    {(capacity?.rules?.gpu_data?.zoneUrba.length === 1 && capacity?.rules?.gpu_data?.zoneUrba[0]?.properties?.libelong) &&
                                        <div className="app__ruleset_document_description">{capacity?.rules?.gpu_data?.zoneUrba[0]?.properties?.libelong}</div>
                                    }
                                </>
                                :
                                // PLU MODEL VERSION
                                <>
                                    <div id="zoneUrba_list" className={`app__sectiondata_widget_value_container_zoneurba_small ${isZoneUrbaOpened ? "app__sectiondata_widget_value_container_zoneurba_large" : ""}`}>
                                        {capacity?.rules?.gpu_data?.zoneUrba_all.map((zoneUrba_data, zoneUrba_index) => {
                                            if (zoneUrba_index < capacity?.rules?.gpu_data?.zoneUrba_all.length - 1) {
                                                return (
                                                    <>
                                                        <ZoneUrba zoneUrba_data={zoneUrba_data} mapShow_change={zoneUrba2_mapShow_change} zoneUrba_mapShow={zoneUrba2_mapShow} />
                                                        <div className="app__bound_line_container" style={{ marginTop: "4px", marginBottom: "5px" }}></div>
                                                    </>
                                                )
                                            }
                                            else {
                                                return (
                                                    <ZoneUrba zoneUrba_data={zoneUrba_data} mapShow_change={zoneUrba2_mapShow_change} zoneUrba_mapShow={zoneUrba2_mapShow} />
                                                )
                                            }
                                        })}
                                    </div>
                                    <div className="app__context_housing_detail_button_container" style={{ marginTop: "6px" }} onClick={() => { handleZoneUrbaOpening() }}>
                                        {isZoneUrbaOpened ?
                                            <div className="app__context_housing_detail_button_up"><img src={ico_arrow} alt="arrow_up" /></div>
                                            :
                                            <div className="app__context_housing_detail_button_down"><img src={ico_arrow} alt="arrow_up" /></div>
                                        }
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                    {/* ZONING URBA 2 */}
                    {(capacity?.isModel === true || (capacity?.rules?.gpu_data?.zoneUrba2 && capacity?.rules?.gpu_data?.zoneUrba2 !== "fetching" && capacity?.rules?.gpu_data?.zoneUrba2.length > 0)) &&
                        <>
                            <div className="app__sectiondata_widget_spacer_10"></div>
                            <div className="app__sectiondata__widget">
                                <div className="app__sectiondata_widget_title">Zonage PLU secondaire</div>
                                {capacity?.isModel === true ?
                                    // PLU MODEL VERSION
                                    <>
                                        {capacity?.rules?.gpu_data?.zoneUrba2_all && capacity?.rules?.gpu_data?.zoneUrba2_all.length > 0 &&
                                            <>
                                                {capacity?.rules?.gpu_data?.zoneUrba2_all.map((zoneUrba2_data, zoneUrba2_index) => {
                                                    if (zoneUrba2_index < capacity?.rules?.gpu_data?.zoneUrba2_all.length - 1) {
                                                        return (
                                                            <>
                                                                <ZoneUrba2 capacity={capacity} zoneUrba2_data={zoneUrba2_data} zoneUrba2_index={zoneUrba2_index} libelle_update={libelle_update} description_update={description_update} label_update={label_update} index_update={index_update} geojson_update={geojson_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                                <div className="app__bound_line_container" style={{ marginTop: "4px", marginBottom: "3px" }}></div>
                                                            </>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <ZoneUrba2 capacity={capacity} zoneUrba2_data={zoneUrba2_data} zoneUrba2_index={zoneUrba2_index} libelle_update={libelle_update} description_update={description_update} label_update={label_update} index_update={index_update} geojson_update={geojson_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                        )
                                                    }
                                                })}
                                            </>
                                        }
                                        <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={zoneUrba2_Create}>Ajouter une zone PLU secondaire</span></div>
                                    </>
                                    :
                                    // CAPACITY VERSION
                                    <>
                                        {capacity?.rules?.gpu_data?.zoneUrba2 && capacity?.rules?.gpu_data?.zoneUrba2 !== "fetching" && capacity?.rules?.gpu_data?.zoneUrba2.length > 0 &&
                                            <>
                                                {capacity?.rules?.gpu_data?.zoneUrba2.map((zoneUrba2_data, zoneUrba2_index) => {
                                                    if (zoneUrba2_index < capacity?.rules?.gpu_data?.zoneUrba2.length - 1) {
                                                        return (
                                                            <>
                                                                <ZoneUrba2 capacity={capacity} zoneUrba2_data={zoneUrba2_data} zoneUrba2_index={zoneUrba2_index} libelle_update={libelle_update} description_update={description_update} label_update={label_update} index_update={index_update} geojson_update={geojson_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                                <div className="app__bound_line_container" style={{ marginTop: "6px", marginBottom: "5px" }}></div>
                                                            </>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <ZoneUrba2 capacity={capacity} zoneUrba2_data={zoneUrba2_data} zoneUrba2_index={zoneUrba2_index} libelle_update={libelle_update} description_update={description_update} label_update={label_update} index_update={index_update} geojson_update={geojson_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                        )
                                                    }
                                                })}
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </>
                    }
                    {/* ZONING CITY */}
                    {(capacity?.isModel === true) &&
                        <>
                            <div className="app__sectiondata_widget_spacer_10"></div>
                            <div className="app__sectiondata__widget">
                                <div className="app__sectiondata_widget_title">Zonage par commune</div>
                                {capacity?.rules?.gpu_data?.zoneCity_all && capacity?.rules?.gpu_data?.zoneCity_all.length > 0 &&
                                    <>
                                        {capacity?.rules?.gpu_data?.zoneCity_all.map((zoneUrba2_data, zoneUrba2_index) => {
                                            if (zoneUrba2_index < capacity?.rules?.gpu_data?.zoneCity_all.length - 1) {
                                                return (
                                                    <>
                                                        <ZoneCity capacity={capacity} zoneUrba2_data={zoneUrba2_data} cityname_update={cityname_update} postcode_update={postcode_update} inseecode_update={inseecode_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                        <div className="app__bound_line_container" style={{ marginTop: "4px", marginBottom: "3px" }}></div>
                                                    </>
                                                )
                                            }
                                            else {
                                                return (
                                                    <ZoneCity capacity={capacity} zoneUrba2_data={zoneUrba2_data} cityname_update={cityname_update} postcode_update={postcode_update} inseecode_update={inseecode_update} mapShow_change={zoneUrba2_mapShow_change} zoneUrba2_mapShow={zoneUrba2_mapShow} zoneUrba2_Delete={zoneUrba2_Delete} />
                                                )
                                            }
                                        })}
                                    </>
                                }
                                <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={zoneCity_Create}>Ajouter une commune</span></div>
                            </div>
                        </>
                    }
                    <div className="app__sectiondata_widget_spacer_10"></div>
                    <div className="app__sectiondata_widget_info_container">
                        <div className="app__sectiondata_widget_info_text">
                            Source : Géoportail de l'Urbanisme
                        </div>
                        <div className="app__sectiondata_widget_info_icon">i</div>
                    </div>
                    <div className="app__sectiondata_widget_spacer_20"></div>

                    {/* DOCUMENTS */}
                    <div className="app__sectiondata_widget_title_container">
                        <div id="section_5_docs" className="app__sectiondata_widget_title">Documents d'urbanisme</div>
                        <div className="app__sectiondata_widget_layer">
                            {/* <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch_rules" checked={mapLayers.rules.isVisible} onChange={() => { layer_Toggle("rules") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch_rules">Toggle</label></div> */}
                        </div>
                    </div>
                    <div className="app__sectiondata__widget">
                        <div className="app__sectiondata_widget_title">Documents applicables</div>
                        <div className="app__sectiondata_widget_value_container">
                            <div className="app__ruleset_document_title" style={{ marginBottom: "2px" }}>{capacity?.rules?.gpu_data?.document?.title}</div>
                            {/* <div className="" style={{ marginBottom: "4px" }}>Dernière procédure approuvée le {(capacity?.rules?.gpu_data?.document?.originalName).substring((capacity?.rules?.gpu_data?.document?.originalName.length - 2))}/{(capacity?.rules?.gpu_data?.document?.originalName).substring((capacity?.rules?.gpu_data?.document?.originalName.length - 4), (capacity?.rules?.gpu_data?.document?.originalName.length - 2))}/{(capacity?.rules?.gpu_data?.document?.originalName).substring((capacity?.rules?.gpu_data?.document?.originalName.length - 8), (capacity?.rules?.gpu_data?.document?.originalName.length - 4))}</div> */}
                            {capacity?.rules?.gpu_data?.document?.originalName &&
                                <div className="" style={{ marginBottom: "4px" }}>Dernière procédure approuvée le {(capacity?.rules?.gpu_data?.document?.originalName.split("_")[2]).substring(6)}/{(capacity?.rules?.gpu_data?.document?.originalName.split("_")[2]).substring(4, 6)}/{(capacity?.rules?.gpu_data?.document?.originalName.split("_")[2]).substring(0, 4)}</div>
                            }
                            <div className="app__land_data_button" style={{ width: "246px" }}><a href={"https://www.geoportail-urbanisme.gouv.fr/document/by-id/" + capacity?.rules?.gpu_data?.document?.id} target="_blank">Fiche détaillée du Géoportail de l'Urbanisme</a></div>
                        </div>
                        {(capacity?.rules?.gpu_data?.files && capacity.rules.gpu_data.files !== "error" && !Array.isArray(capacity.rules.gpu_data.files) && Object.keys(capacity.rules.gpu_data.files).length > 0) &&
                            <>
                                <div className="app__sectiondata_widget_spacer_30"></div>
                                <div className="app__sectiondata_widget_title_container">
                                    <div className="app__sectiondata_widget_title">Liste des pièces écrites</div>
                                    {window.innerWidth > 550 &&
                                        <a className="app__ruleset_download_container" href={capacity?.rules?.gpu_data?.document?.archiveUrl} target="_blank">
                                            <div className="app__ruleset_download_text">Télécharger toutes les pièces au format Zip</div>
                                            <div className="app__ruleset_download_ico"><img src={ico_download} alt="ico_download" /></div>
                                        </a>
                                    }
                                </div>
                                {Object.keys(capacity?.rules?.gpu_data?.files).map((file_group, index_group) => {
                                    return (
                                        <div key={"filegroup_" + index_group}>
                                            {index_group > 0 &&
                                                <div className="app__bound_line_container"></div>
                                            }
                                            <FileGroup file_group={file_group} index_group={index_group} files={capacity?.rules?.gpu_data?.files} capacity={capacity} file_Update_Params={file_Update_Params} />
                                        </div>
                                    )
                                })}
                            </>
                        }
                        {/* <div className="app__sectiondata_widget_spacer_10"></div>
                        <a className="app__ruleset_button" style={{ width: "265px" }} href={capacity?.rules?.gpu_data?.document?.archiveUrl} target="_blank"><div className="app__ruleset_ico"><img src={ico_file_white} alt="ico_file" /></div><div>Télécharger toutes les pièces au format ZIP</div></a> */}
                    </div>
                    {/* DOC ID LIST */}
                    {(capacity?.isModel === true && capacity?.rules?.gpu_data?.document?.id_list) &&
                        <>
                            <div className="app__sectiondata_widget_spacer_10"></div>
                            <div className="app__sectiondata__widget">
                                <div className="app__sectiondata_widget_title">Liste des documents d'urbanisme applicables</div>
                                {capacity?.rules?.gpu_data?.document?.id_list && capacity?.rules?.gpu_data?.document?.id_list.length > 0 &&
                                    <>
                                        {capacity?.rules?.gpu_data?.document?.id_list.map((docIdItem, docIdItem_index) => {
                                            if (docIdItem_index < capacity?.rules?.gpu_data?.document?.id_list.length - 1) {
                                                return (
                                                    <>
                                                        <DocIdItem capacity={capacity} docIdItem={docIdItem} docIdItem_index={docIdItem_index} docIdRef_Update={docIdRef_Update} docIdRef_Delete={docIdRef_Delete} />
                                                        <div className="app__bound_line_container" style={{ marginTop: "4px", marginBottom: "3px" }}></div>
                                                    </>
                                                )
                                            }
                                            else {
                                                return (<DocIdItem capacity={capacity} docIdItem={docIdItem} docIdItem_index={docIdItem_index} docIdRef_Update={docIdRef_Update} docIdRef_Delete={docIdRef_Delete} />)
                                            }
                                        })}
                                    </>
                                }
                                <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={docIdRef_Create}>Ajouter une référence</span></div>
                            </div>
                        </>
                    }
                    <div className="app__sectiondata_widget_spacer_10"></div>
                    <div className="app__sectiondata_widget_info_container">
                        <div className="app__sectiondata_widget_info_text">
                            Source : Géoportail de l'Urbanisme
                        </div>
                        <div className="app__sectiondata_widget_info_icon">i</div>
                    </div>
                    <div className="app__sectiondata_widget_spacer_20"></div>
                </>
            }


            {capacity?.rules?.gpu_data === "fetching" ?
                <div className="app__sectiondata_loading_container">
                    <div className="app__sectiondata_loading"></div>
                    <div className="app__sectiondata_loading_text">Nous analysons les données réglementaires sur le Géoportail de l'Urbanisme</div>
                </div>
                :
                <>
                    {/* <div className="app__sectiondata_widget_title">Définition des règles</div> */}
                    <div className="app__sectiondata_widget_title_container">
                        <div id="section_5_rules" className="app__sectiondata_widget_title">Règles d'urbanisme</div>
                        <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch_rules" checked={mapLayers.rules.isVisible} onChange={() => { layer_Toggle("rules") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch_rules">Toggle</label></div>
                        </div>
                    </div>
                    {/* AI TOOL*/}
                    {/* <AIplu capacity={capacity} setCapacity={setCapacity} ruleGroup_Update={ruleGroup_Update} /> */}
                    {!capacity?.isModel && capacity?.rules?.gpu_data?.zoneUrba2 &&
                        <AIpluFake capacity={capacity} setCapacity={setCapacity} setRuleUpdateTracker={setRuleUpdateTracker} setIsAIRunning={setIsAIRunning} />
                    }
                    {/* LIST */}
                    <div className="app__ruleset_container">
                        <div className={`app__ruleset_mask_hidden ${isAIRunning ? "app__ruleset_mask" : ""}`}></div>
                        <DragAndDrop onDragEnd={handleDragEnd}>
                            <Drop id="droppable" type="droppable-category">
                                {capacity.rules.ruleset.map((category, categoryIndex) => {
                                    return (
                                        <Drag
                                            className="draggable-category"
                                            key={category.id}
                                            id={category.id + "_drag"}
                                            index={categoryIndex}
                                            type="category"
                                            subtype=""
                                        >
                                            <div key={category.id + "_container"} id={category.id + "_container"} className="category-container">
                                                <Document key={"doc__" + categoryIndex} capacity={capacity} id={category.id} name={category.name} item={category} title_Create={title_Create} ruleCatalog_Open={ruleCatalog_Open} ruleGroup_Update={ruleGroup_Update} ruleGroup_Delete={ruleGroup_Delete} ruleGroup_ZoneUrba_Update={ruleGroup_ZoneUrba_Update} ruleGroup_Duplicate={ruleGroup_Duplicate} />

                                                <Drop key={category.id} id={category.id} type="droppable-item" className="test">
                                                    {category.items.map((item, index) => {
                                                        return (
                                                            <Drag
                                                                className={`draggable ${item.type === "title" ? "app__ruleset_title_container" : item.type === "rule" ? "app__ruleset_rule_container" : ""} ${(item.type === "rule" && ((item?.interpreted && item?.interpreted.length === 0) || item?.data?.params?.condition?.data?.interpreted === false || (item?.data?.params?.perimeter?.data?.interpreted && item?.data?.params?.perimeter?.data?.interpreted.length === 0))) ? "app__ruleset_rule_container_invalid" : ""} ${item?.isIgnored === true ? "app__ruleset_rule_container_ignored" : ""}`}
                                                                key={"item_" + item.id}
                                                                id={"item_" + item.id}
                                                                index={index}
                                                                type="item"
                                                                subtype={item.type}
                                                            >
                                                                <div key={"title__" + categoryIndex + "_" + index}>
                                                                    {item.type === "title" &&
                                                                        <Title key={"title__" + categoryIndex + "_" + index} rule_id={item.id} name={item.name} item={item} title_Update={title_Update} title_Delete={title_Delete} title_OpenClose={title_OpenClose} ruleCatalog_Open={ruleCatalog_Open} />
                                                                    }
                                                                    {item.type === "rule" &&
                                                                        <Rule key={"rule__" + categoryIndex + "_" + index} rule_id={item.id} name={item.name} data={item.data} ruleCatalog_Open={ruleCatalog_Open} rule_Update={rule_Update} rule_Update_Source={rule_Update_Source} rule_Update_Comment={rule_Update_Comment} rule_Update_Title={rule_Update_Title} rule_Update_Ignorance={rule_Update_Ignorance} rule_Delete={rule_Delete} condition_Delete={condition_Delete} perimeter_Delete={perimeter_Delete} capacity={capacity} highlightedRule={highlightedRule} setHighlightedRule={setHighlightedRule} rule={item} ruleset={category} mapDrawMode={mapDrawMode} setMapDrawMode={setMapDrawMode} hiddenRule={hiddenRule} setHiddenRule={setHiddenRule} />
                                                                    }
                                                                </div>
                                                            </Drag>
                                                        );
                                                    })}
                                                </Drop>
                                                {/* <div className="app__ruleset_placeholder_container_box">
                                        <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={() => { title_Create(category.id) }}>Ajouter un titre</span></div>
                                        <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={() => { ruleCatalog_Open(category.id, "rule") }}>Ajouter une règle</span></div>
                                    </div> */}
                                                <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" style={{ marginRight: "8px" }} onClick={() => { title_Create(category.id) }}>Ajouter un titre</span> ou <span className="app__ruleset_rule_condition_link" style={{ marginLeft: "8px" }} onClick={() => { ruleCatalog_Open(category.id, "rule") }}>Ajouter une règle</span></div>
                                            </div>
                                        </Drag>
                                    );
                                })}
                            </Drop>
                        </DragAndDrop>
                        <div className="app__ruleset_placeholder_container"><span className="app__ruleset_rule_condition_link" onClick={ruleGroup_Create}>Ajouter un ensemble de règles</span></div>
                    </div>
                </>
            }

        </>
    );
};

export default List;